import { z } from 'zod'

export default z.object({
  __typename: z.literal('EquipmentVistaItem').default('EquipmentVistaItem'),
  id: z.string(),
})
